<template lang="pug">

v-app
  Toolbar

  v-main(v-if="access.locked")
    LockScreen

  template(v-else)
    Breadcrumbs

    v-main
      v-container.main-container
        router-view

  Footer

</template>


<script>
import Footer from './components/layouts/blocks/footer'
import Toolbar from './components/layouts/blocks/toolbar'
import Breadcrumbs from './components/layouts/blocks/breadcrumbs'
import LockScreen from './components/access/LockScreen'
import { access } from './common/access'

export default {
  name: 'App',

  components: {
    Toolbar,
    Footer,
    Breadcrumbs,
    LockScreen,
  },

  data() {
    return {
      access,
    }
  },
}
</script>

<style lang="sass">

// Global styles
*
  box-sizing: border-box

body
  font-family: 'Inter', 'Roboto', sans-serif
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing: grayscale

// Fix iOS double-tap zoom on clickable elements
button, [role="button"], .v-btn, a, [tabindex]
  touch-action: manipulation
  -webkit-tap-highlight-color: transparent

// Fix for navigation and clickable cards
.nav-button, .nav-card, .breadcrumb-item, .header-logo, .header-site
  touch-action: manipulation
  -webkit-tap-highlight-color: transparent

.l-page
  height: 100%

// Custom scrollbar
::-webkit-scrollbar
  width: 8px

::-webkit-scrollbar-track
  background: rgba(0,0,0,0.1)

::-webkit-scrollbar-thumb
  background: rgba(0,0,0,0.3)
  border-radius: 4px

::-webkit-scrollbar-thumb:hover
  background: rgba(0,0,0,0.5)

html
  overflow-y: auto

</style>

<style lang="sass" scoped>

.v-application
  background: #f8fafc !important
  min-height: 100vh

.main-container
  height: 100%
  padding: 0 !important
  max-width: none !important
</style>
